const StatisticCard = ({
  icon,
  title,
  content,
  gradientClassName,
  spacing,
  height,
  width,
  iconWidth,
  contentWidth,
  contentPadding,
  textClassName,
  iconClassName
}: {
  icon: any; // icon to use for card
  title: string; // bottom text to display
  content: string; // value to display
  gradientClassName: string;
  spacing?: string; // right side spacing
  height?: string; // height
  width?: string;
  iconWidth?: string;
  contentWidth?: string;
  contentPadding?: string;
  textClassName?: string; // override text color
  iconClassName?: string; // override icon stroke/color
}) => {
  const Icon = icon;
  return (
    <div
      className={`flex ${
        height ? `h-[${height}]` : "h-[85px] xl:h-[100px] 2xl:h-[130px]"
      }
      ${
        width ? `${width}` : ""
      } items-center bg-gradient-to-r from-30%  ${gradientClassName} rounded to-100% ${
        textClassName ? textClassName : "text-white"
      } ${spacing}`}
    >
      <Icon
        className={`h-full ${
          iconWidth ? iconWidth : "w-1/4"
        } ${iconClassName ? iconClassName : "stroke-white"} pl-4`}
      />
      <div
        className={`${contentWidth ? contentWidth : "w-3/4"} text-center ${
          contentPadding ? contentPadding : ""
        }`}
      >
        <p className="text-center text-userCounterNum">{content}</p>
        <p className="text-center text-base">{title}</p>
      </div>
    </div>
  );
};

export default StatisticCard;
